import React, { forwardRef } from "react";
import { Icon as IconButton } from "@churchofjesuschrist/eden-buttons";
import PropTypes from "prop-types";
import { jsx as _jsx } from "react/jsx-runtime";
const Action = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    label = "Action",
    href,
    active,
    disabled,
    inverted,
    Icon,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(IconButton, {
    ref: ref,
    href: href,
    disabled: disabled,
    "aria-pressed": active,
    inverted: inverted,
    "aria-label": label,
    ...props,
    children: /*#__PURE__*/_jsx(Icon, {
      size: "1.5rem"
    })
  });
});
Action.displayName = "Action";
export default Action;
Action.propTypes = {
  /** Hidden text label. */
  label: PropTypes.string,
  /** Icon component to display in the button. */
  Icon: PropTypes.func.isRequired,
  /** If present, the root element is an `<a>`, otherwise it's a `<button>`. */
  href: PropTypes.string,
  /** When present, the action becomes a "toggle" button. The value indicates whether it is toggled on or not. To indicate that a toggle action is off use `aria-pressed={false}` instead of excluding the prop. */
  "aria-pressed": PropTypes.oneOf([true, false]),
  /** Whether to disable the button. */
  disabled: PropTypes.bool,
  /** Whether to invert the button styles. (deprecated) */
  inverted: PropTypes.bool
};